// components/ActionSection.tsx

import { Button } from '@/presentation/components';
import {
  DataTable,
  DataTableColumn,
} from '@/presentation/components/common/DataTable';
import { PageTitle } from '@/presentation/components/common/PagesTitle';

import styles from '../ActionPage.module.css';

interface ActionItem {
  id: number;
  nombre: string;
  usuario: string;
  fecha: Date;
}

interface ActionSectionProps {
  title: string;
  buttonLabel: string;
  data: ActionItem[];
  columns: DataTableColumn<ActionItem>[];
  emptyMessage: string;
  onCreate: () => void;
}

export function ActionSection({
  title,
  buttonLabel,
  data,
  columns,
  emptyMessage,
  onCreate,
}: ActionSectionProps) {
  return (
    <section style={{ padding: '24px' }}>
      <div className={styles.header}>
        <PageTitle title={title} />

        <Button onClick={onCreate}>
          {buttonLabel}
        </Button>
      </div>

      <DataTable
        columns={columns}
        data={data}
        emptyMessage={emptyMessage}
      />
    </section>
  );
}